import { PresentedDocumentationRepository, PresentedDocumentationItem } from '@/Domain/Documentation/Presented'
import { ApplicantNif } from '@/Domain/Documentation/ApplicantNif'
import { DocumentationType } from '@/Domain/Documentation/DocumentationType'
import { ApiClient } from '@/Domain/ApiClient'

export class AxiosPresentedDocumentationRepository implements PresentedDocumentationRepository {
  private _apiClient: ApiClient

  constructor (apiClient: ApiClient) {
    this._apiClient = apiClient
  }

  async proceduresWithPresentedDocumentation (
    applicantNif: ApplicantNif,
    documentationType: DocumentationType
  ): Promise<PresentedDocumentationItem[]> {
    try {
      const result = await this._apiClient.makeGetRequest(
        `/sobree/api/documentation/query/${applicantNif.codeId()}/${documentationType.value()}`,
        {}
      )
      return result.data.data
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
